import { render } from "./RemarkDialog.vue?vue&type=template&id=66da6d5b"
import script from "./RemarkDialog.vue?vue&type=script&lang=js"
export * from "./RemarkDialog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__